/**
 * Hafif i18n: tüm görünen metin `tr.ts` anahtarlarından gelir (BRIEF: yalnız `tr`, ikinci dil = yeni dosya).
 * `{brand}` otomatik olarak `brand.ts` adıyla dolar (K36); diğer yer tutucular `vars` ile.
 */
import { brand } from "../brand.ts";
import { tr } from "./tr.ts";

export type TrKey = keyof typeof tr;
type Vars = Record<string, string | number>;

export function t(key: TrKey, vars?: Vars): string {
  const raw: string = tr[key];
  return raw.replace(/\{(\w+)\}/g, (_, k: string) => (k === "brand" ? brand.name : String(vars?.[k] ?? `{${k}}`)));
}

/** Türkçe büyük harf (CSS ile değil, kodda): baş harf avatarı vb. */
export const upperTr = (s: string): string => s.toLocaleUpperCase("tr");
